import { render, staticRenderFns } from "./external_shipping_new.vue?vue&type=template&id=fbdf8bc2"
import script from "./external_shipping_new.vue?vue&type=script&lang=js"
export * from "./external_shipping_new.vue?vue&type=script&lang=js"
import style0 from "./external_shipping_new.vue?vue&type=style&index=0&id=fbdf8bc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports